<template>
  <modalForm :title="$t('flow.editTitle')" :submit-label="$t('actions.save')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-1">{{ error }}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('automations.name') }}:</p>
      <input type="text" name="name" v-model="name" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.name.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4" v-if="this.agentStore.collection.length > 0">
      <p class="text-sm font-medium text-gray-700 mb-1">{{ $t('flow.agents') }}:</p>
      <Multiselect
        v-model="agents"
        :options="availableAgents"
        :searchable="true"
        mode="multiple"
        :search="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :placeholder="$t('flow.selectAgents')"
        track-by="label"
        :preselect-first="true"
        valueProp="id"
        label="label"
        :multipleLabel="multipleLabel"
        :canDeselect="false"
        :canClear="false"
        :classes="{multipleLabel: 'text-gray-500 text-sm flex items-center h-full absolute left-0 top-0 pointer-events-none bg-transparent leading-snug pl-3.5 rtl:left-auto rtl:right-0 rtl:pl-0 rtl:pr-3.5'}"
      >
        <template v-slot:singlelabel="{ value }">
          <div class="multiselect-single-label">
            {{value.id}}
          </div>
        </template>
        <template v-slot:option="{ option }">
          <AgentAvatar v-bind:agent="option.agent" diameter="28" classes="inline-block -space-x-2 relative z-0 overflow-hidden mr-2" />
          <span class="text-sm font-medium text-gray-700">{{option.label}}</span>
        </template>
      </Multiselect>
      <div class="mt-4 h-96 overflow-y-scroll scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-50" style="margin-bottom: -1rem">
        <table class="min-w-full divide-y divide-gray-300">
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="agent of selectedAgents" v-bind:key="agent.id">
              <GroupAgentItem v-on:remove-agent="removeAgent" :agent="agent" />
            </tr>
          </tbody>
        </table>
      </div>
      <div v-for="error of v$.agents.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>

  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import modalForm from '../../building_blocks/modalForm'
import formViewMixin from '../../building_blocks/formViewMixin'
import groupModel from '../../../models/group'
import { useAgentStore } from '@/stores/agents';
import Multiselect from '@vueform/multiselect'
import AgentAvatar from '../../agents/AgentAvatar.vue'
import GroupAgentItem from "./GroupAgentItem";


export default {
  mixins: [formViewMixin],
  props: ['group'],
  name: 'GroupEdit',
  setup () {
    let agentStore = useAgentStore();
    return { v$: useVuelidate(), agentStore }
  },
  components: {
    GroupAgentItem,
    modalForm,
    AgentAvatar,
    //
    Multiselect,
  },
  created() {
    this.name = this.group.attributes.name;
    let agentIds = [];
    this.group.relationships.agents.data.forEach(a => {
      agentIds.push(a.id);
    });
    this.agents = agentIds;
  },
  computed: {
    availableAgents() {
      let agents = [];
      this.agentStore.collection.forEach(a => {
        agents.push({id: a.id, label: a.attributes.name, agent: a});
      });
      return agents;
    },
    selectedAgents() {
      return this.agentStore.getAgentsByIds(this.agents);
    }
  },
  methods: {
    async onFormValid() {
      let response;
      let groupData = groupModel.buildUpdate(this.name, this.group.id, this.agents);
      try {
        response = await groupModel.updateGroup(this.group.id, groupData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('flow.errorUpdating');
      }
      if (response && response.status === 204) {
          this.error = '';
          this.$emit('update-finished-event');
      }
    },
    cancel() {
      this.$emit('update-finished-event');
    },
    toggleActive() {
      this.active = !this.active;
    },
    multipleLabel() {
      return [this.$t('flow.selectAgents')];
    },
    removeAgent(agent) {
      let index = this.agents.indexOf(agent.id);
      if (index !== -1) {
        this.agents.splice(index, 1);
      }
    }
  },
  data() {
    return {
      'name': '',
      'agents': '',
      'error': '',
    }
  },
  validations () {
    return {
      'name': { required },
      'agents': { },
    }
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
